let validateElementsMax = document.querySelectorAll('[max]')
validateElementsMax.forEach(function (element) {
    let max = parseInt(element.getAttribute('max'))
    element.addEventListener("change", function () {
        let value = this.value
        if (value.length > max) this.value = value.substring(0, max)
    });
})
